import { useHead, useRuntimeConfig, useServerHead } from "#imports";
export function useSchemaOrg(input) {
  const config = useRuntimeConfig()["nuxt-schema-org"] || useRuntimeConfig().public["nuxt-schema-org"];
  const script = {
    type: "application/ld+json",
    key: "schema-org-graph",
    nodes: input,
    ...config?.scriptAttributes || {}
  };
  if (import.meta.server) {
    return useServerHead({
      script: [script]
    });
  } else {
    if (config?.reactive) {
      return useHead({
        script: [script]
      });
    }
  }
}
